import React from 'react';
import DialogBase from '@material-ui/core/Dialog';

const Dialog = (props) => <DialogBase {...props} />;

export default Dialog;
